import Cookies from 'js-cookie';

//waits for our DOM to load
document.addEventListener('DOMContentLoaded', function() {

    //grab the fulfillment type from the cookie
    let fulfillment_type = Cookies.get('bt_fulfillment_type');

    //check if we're on the checkout page
    let is_checkout = document.body.classList.contains('page-template-page-checkout');

    //if we're on checkout page and we have a fulfillment type of mobile fitting OR we have a home delivery type and delivery is disabled...
    if(is_checkout && (fulfillment_type && fulfillment_type === 'mobile_fitting' || fulfillment_type && fulfillment_type === 'home_delivery' && cart_ajax_object.delivery_allowed == 'false')) {

        //we can't allow the user to proceed, so we'll redirect them to the shopping cart
        window.location.href = '/shopping-cart';
    }
});